'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './category-edit.routes';

export class CategoryEditComponent {

  constructor(Auth, SettingsService, $stateParams, dialogs, $state) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.recipientListId = $stateParams.id;

    this.SettingsService.getByName({name: 'config.app'}, setting => {
      this.settings = setting;
      this.categories = setting.data.moduleConfig.general.businessTypes.join("\n");
    }, err => {
      console.log('Could not load settings from server');
    });

    CodeMirror.defineOption("mode", "text/plain");
    CodeMirror.defineOption("styleActiveLine", true);
    CodeMirror.defineOption("lineNumbers", true);
  }

  sortList(order) {
    var sorted = this.categories.split(/\n/).sort(function (a, b) {
      if (order == 'asc') {
        return a.localeCompare(b);
      } else {
        return b.localeCompare(a);
      }
    });
    this.categories = sorted.join("\n");
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The categories have been changed successfully");
        dlg.result.then(() => {
          that.$state.go("category-edit");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      var lines = this.categories.split(/\n/);
      this.settings.data.moduleConfig.general.businessTypes = [];
      for (let i=0; i < lines.length; i++) {
        // only push this line if it contains a non whitespace character.
        if (/\S/.test(lines[i])) {
          this.settings.data.moduleConfig.general.businessTypes.push(lines[i].trim());
        }
      }

      this.SettingsService.update({id: this.settings._id}, this.settings, onSuccess, onError);
    }
  }
}

export default angular.module('conduuApp.categoryEdit', [uiRouter])
  .config(routes)
  .component('categoryEdit', {
    template: require('./category-edit.html'),
    controller: CategoryEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/category-edit/category-edit.component.js